import type { FC, ReactChild } from 'react';
import React, { useMemo } from 'react';

import type { TextAlignment } from './../../ricos-types/index.js';

type RicosAlignmentContextProps = {
  textAlignment?: TextAlignment;
  children: ReactChild;
};

type ContextType = {
  textAlignment?: TextAlignment;
};

export const RicosAlignmentContext = React.createContext<ContextType>(
  null as unknown as ContextType
);

export const RicosAlignmentContextProvider: FC<RicosAlignmentContextProps> = ({
  textAlignment,
  children,
}) => {
  const textAlignmentValue = useMemo(() => {
    return { textAlignment };
  }, [textAlignment]);

  return (
    <RicosAlignmentContext.Provider value={textAlignmentValue}>
      {children}
    </RicosAlignmentContext.Provider>
  );
};
